module.exports = __webpack_public_path__ + "static/media/header2.18973232.jpg";